module.exports = __webpack_public_path__ + "static/media/sa.f12a5847.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/countriesFlags/sa.svg
// module id = 1468
// module chunks = 0